import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { ConsoleRequest, DataProviderType } from '../../../utils/request';
import { PhasrMonitoredRulesMethod } from '../types';
import { BehaviorProfilesOutput } from '../../../phasrRecommendations/phasrRestrictedProfilesSelector/types';

export class PhasrMonitoredRulesGridBaseDataProvider extends BaseWebComponentDataProvider {
  endpoint = 'MonitoredRules';
  public async updateUserBehaviouralProfiles(objectId: string, ruleId: number, companyId: string,  changes: BehaviorProfilesOutput | null = null): Promise<{success: boolean, code?: number}> {
    return await ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.CORE,
      endpoint: this.endpoint,
      method: PhasrMonitoredRulesMethod.UPDATE_BEHAVIOUR_ACTIONS,
      payload: {
        objectId: objectId,
        ruleId: ruleId,
        companyId: companyId,
        actionName: Application.Main.getPhasrDictionary()[ruleId]?.['rule_name'] ?? 'N/A',
        changes: changes,
      },
    });
  }
}
